import {
  REQUEST_LANG,
  RECEIVE_LANG_DATA,
  CLEAR_LANG_DATA,
} from "../constants/Lookups";

const initState = {
  lkLanguages: [],
};

const lookup = (state = initState, action) => {
  switch (action.type) {
    case REQUEST_LANG:
      return {
        ...state,
      };
    case RECEIVE_LANG_DATA:
      return {
        ...state,
        lkLanguages: action.data,
      };
    case CLEAR_LANG_DATA:
      return {
        ...state,
        lkLanguages: null,
      };
    default:
      return state;
  }
};

export default lookup;
